<div class="card list-view-media stop-overflow">
  <div class="card-block">
    <div class="media push-sm-12">
      <a
        class="media-left"
        [routerLink]="['/profile', comment.author.username]"
      >
        <img
          *ngIf="comment.author.image"
          class="comment-user-image"
          [src]="comment.author.image"
          alt="comment-user-image"
        />
        <img
          *ngIf="!comment.author.image"
          class="comment-user-image"
          [src]="defaultUserImg"
          alt="comment-user-image"
        />
      </a>
      <div class="media-body">
        <div>
          <h6 style="display: block">
            <a
              class="comment-author"
              [routerLink]="['/profile', comment.author.username]"
            >
              {{ comment.author.username | slice: 0:30 }}
            </a>
          </h6>
          <div style="display: block; margin-bottom: 0.5rem">
            <span class="text-muted">
              Posted on {{ comment.createdAt | date: "longDate" }}
            </span>
            <div [hidden]="!canModifyComment" style="display: inline-block">
              <i
                class="icofont icofont-trash text-primary"
                (click)="openCommentDeleteConfirmation()"
              >
              </i>

              <!-- Edit-comments-button -->
              <edit-comment-button
                style="margin-left: 2px"
                [currentUser]="currentUser"
                [discussion]="discussion"
                [commentToEdit]="comment"
                [currentPanelMember]="currentPanelMember"
                class="pull-right text-primary"
              >
              </edit-comment-button>
              <!-- Edit-comments-button -->
            </div>
          </div>
        </div>
        <div class="f-13 text-muted m-b-15">
          Bio: {{ comment.author.bio | slice: 0:60 }} ...
        </div>

        <!-- Mark as host or panel member -->
        <div *ngIf="isHost === true">
          <label
            class="j-span2 label label-lg bg-default popular-tag label-primary"
          >
            Host
          </label>
        </div>

        <div *ngIf="comment.panel.member === true">
          <label
            class="j-span2 label label-lg bg-default popular-tag label-success"
          >
            Panel member credentials:
          </label>
          <a [routerLink]="['/profile', comment.author.username]">
            <span
              [innerHTML]="comment.panel.credential | slice: 0:150"
              class="text-muted"
            >
            </span>
          </a>
        </div>
        <!-- Mark as host or panel member -->
      </div>

      <!-- Mark as host or panel member -->
      <div *ngIf="isHost === true">
        <span class="fa fa-microphone f-50 text-primary"> </span>
      </div>

      <div *ngIf="comment.panel.member === true">
        <span class="fa fa-check-circle f-50 text-success"> </span>
      </div>
      <!-- Mark as host or panel member -->
    </div>
    <hr [ngClass]="{ 'header-line': comment.panel.member === true }" />
    <div>
      <div>
        <p class="comment-body">
          <span *ngIf="comment.replyTo" class="text-primary">
            <i class="icofont icofont-speech-comments text-info"></i> &nbsp; @
            {{ comment.replyTo }}
          </span>
          <span [innerHtml]="comment.body"></span>
        </p>
      </div>
    </div>
    <div class="key-buttons">
      <!-- Upvote button start -->
      <upvote-comment-button
        [comment]="comment"
        [discussion]="discussion"
        [currentPanelMember]="currentPanelMember"
        (onToggle)="onToggleUpvote($event)"
        class="pull-left"
      >
      </upvote-comment-button>
      <!-- Upvote button end-->

      <!-- Downvote button start -->
      <downvote-comment-button
        [comment]="comment"
        [discussion]="discussion"
        [currentPanelMember]="currentPanelMember"
        (onToggle)="onToggleDownvote($event)"
        class="pull-left"
      >
      </downvote-comment-button>
      <!-- Downvote button end -->

      <!-- Discussion-comments-button -->
      <add-comment-button
        [currentUser]="currentUser"
        [discussion]="discussion"
        [currentPanelMember]="currentPanelMember"
        [commentRepliedTo]="comment"
        class="pull-left"
      >
      </add-comment-button>
      <!-- Discussion-comments-button -->
    </div>
  </div>
</div>
